import React from 'react';
import PropTypes from 'prop-types';
import { Input, Form } from 'antd';

const FormItem = Form.Item;

const InputFormItem = (props) => {
    const { container_class, label, validate_status, help, error_key, rules, input_class, input_name, type, placeholder, disabled, onChange, getFieldDecorator } = props;

    return (
        <FormItem className={container_class} label={label} validateStatus={validate_status} help={help}>
            {
                getFieldDecorator (error_key, {
                    rules: rules,
                })(
                    <Input type={type} placeholder={placeholder} className={input_class} name={input_name} disabled={disabled} onChange={onChange} />
                )
            }
        </FormItem>
    );
};

InputFormItem.propTypes = {
 error_key: PropTypes.string.isRequired,
    getFieldDecorator: PropTypes.func.isRequired,
    rules: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    input_class: PropTypes.string,
    input_name: PropTypes.string,
    container_class: PropTypes.string,
    validate_status: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string,PropTypes.node]),
    disabled: PropTypes.bool,
    type: PropTypes.string,
};

InputFormItem.defaultProps = {
    rules:[],
    input_class: "ori-font-xs ori-height-40 ori-lr-pad-20 ori-border-radius-20",
    disabled: false,
};

export default InputFormItem;


// WEBPACK FOOTER //
// ./src/components/form/formitem/inputformitem/index.js